/* ========================================================================
 * .noConflict()
 * Enclosed everything within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {
    $(document).ready(function () {
        $(".liquid").imgLiquid();

        setTimeout(function(){
            $('body, html').scrollTop(0);
            $('.load-overlay').velocity('fadeOut');
        }, 100);

        $('.deliverables .rows').matchHeight();
        $('.item-publicates .title').matchHeight();
        $('.box-news .item-news .name').matchHeight();
        
        topMenuChange();

        $('.box-chess-img-pl').imgLiquid();
        $('.item-laboratory').imgLiquid();
        $('.news-img').imgLiquid();

        $('.btn-header-menu').click(function() {
            if ($('.mob-menu-list').css('display') == 'none') {
                $('.mob-menu-list').css({'display':'block'});
            } else {
                $('.mob-menu-list').css({'display':'none'});
            }
        });

    });

    $(window).scroll(function() {
        topMenuChange();
        checkDivs();
    });

    function topMenuChange()
    {
        if (getBodyScrollTop() > 100) {
            $('.menu-fix-top-out').css({'display':'block'});
        } else {
            $('.menu-fix-top-out').css({'display':'none'});
        }
    }

    function getBodyScrollTop()
    {
        return self.pageYOffset || (document.documentElement && document.documentElement.scrollTop) || (document.body && document.body.scrollTop);
    }

    $.fn.isOnScreen = function(){
          
      var win = $(window);
          
      var viewport = {
        top : win.scrollTop(),
        left : win.scrollLeft()
      };
      
      viewport.right = viewport.left + win.width();
      viewport.bottom = viewport.top + win.height();
          
      var bounds = this.offset();
          bounds.right = bounds.left + this.outerWidth();
          bounds.bottom = bounds.top + this.outerHeight();
          
      return (!(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom));
          
    };

    var checkDivs = function(){
      $('.anim.start').each(function(){
        if($(this).isOnScreen() === true) {
          var anim = $(this).attr('data-anim');
          var speed = $(this).attr('data-speed');
          var delay = $(this).attr('data-delay');
          
          if(speed === null){
            speed = 500;
          }

          if(anim === 'fadeUp'){
            $(this).velocity({translateZ: 0, translateY: '-30px', opacity: 0}, {duration: 0, delay: 0});
            $(this).removeClass('start').addClass('finish');
            $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
          }

          if(anim === 'fadeDown'){
            $(this).velocity({translateZ: 0, translateY: '30px', opacity: 0}, {duration: 0, delay: 0});
            $(this).removeClass('start').addClass('finish');
            $(this).velocity({translateZ: 0, translateY: '0px', opacity: 1}, {duration: speed, delay: delay});
          }

          if(anim === 'fadeLeft'){
            $(this).velocity({translateZ: 0, translateX: '-30px', opacity: 0}, {duration: 0, delay: 0});
            $(this).removeClass('start').addClass('finish');
            $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
          }

          if(anim === 'fadeRight'){
            $(this).velocity({translateZ: 0, translateX: '30px', opacity: 0}, {duration: 0, delay: 0});
            $(this).removeClass('start').addClass('finish');
            $(this).velocity({translateZ: 0, translateX: '0px', opacity: 1}, {duration: speed, delay: delay});
          }

        }
      });
    };

    $(window).resize(function(){
      checkDivs();
    });

    $(document).ready(function(){
      $('.anim').each(function(){
        $(this).addClass('start').css('opacity', 0);
      });
      checkDivs();
    });
    
})(jQuery); // Fully reference jQuery after this point.